var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ValidationError } from '../../types';
export const getFailureRedirectUrl = (response, appSettings, redirectUrlMap) => {
    var _a;
    if (!response) {
        return '';
    }
    return (redirectUrlMap === null || redirectUrlMap === void 0 ? void 0 : redirectUrlMap[response.status]) || ((_a = appSettings === null || appSettings === void 0 ? void 0 : appSettings.redirectUrlMap) === null || _a === void 0 ? void 0 : _a[response.status]) || '';
};
export const getUnknownErrorResponse = (error) => new Response(undefined, {
    status: 500,
    statusText: error.message || 'An unspecified error has occurred',
});
export const getApiResponseData = (res) => {
    var _a;
    return ((_a = res) === null || _a === void 0 ? void 0 : _a.responseData) ? res.responseData : res;
};
export const getUnknownError = () => new Error('An unspecified error has occurred');
export const getValidationErrors = (res) => {
    var _a, _b;
    if ((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.validationErrors) === null || _b === void 0 ? void 0 : _b.length) {
        return new ValidationError(res.validationErrors);
    }
};
export const handleApiResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    if (!response) {
        throw getUnknownError();
    }
    if (response.status === 403) {
        throw new Error('A forbidden error has occurred');
    }
    else if (response.status === 404) {
        throw new Error('A not found error has occurred');
    }
    else if (response.status === 401) {
        throw new Error('A token error has occurred');
    }
    else if (response.status >= 405) {
        throw new Error('An unspecified error has occurred');
    }
    return response.json();
});
export const handleErrorCallback = (params, error) => {
    try {
        if (params === null || params === void 0 ? void 0 : params.errorHandler) {
            params.errorHandler(error);
            if (console === null || console === void 0 ? void 0 : console.error) {
                console.error(error);
            }
        }
    }
    catch (ignore) { }
};
export const handleSuccessCallback = (params) => (data) => {
    try {
        if (params === null || params === void 0 ? void 0 : params.successHandler) {
            params.successHandler(data);
        }
    }
    catch (ignore) { }
};
export const isValidationError = (error) => (error === null || error === void 0 ? void 0 : error.name) === 'validation_error';
//# sourceMappingURL=utils.js.map